module.exports = __webpack_public_path__ + "hangup.bb3fb351.mp3";